import React, { memo, useEffect, useState } from "react";
import * as S from "./tabsStyle";
import { useSelector } from "react-redux";

const Tab = ({ children, onTabSelected }) => {
  const activeTab = useSelector(
    (state) => state.rootReducer.loginUser.activeBudgetTab
  );
  const [itemId, setItemId] = useState(activeTab);

  useEffect(() => {
    onTabSelected && onTabSelected(itemId);
  }, [itemId, onTabSelected]);

  return (
    <S.TabContainer>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          onClick: () => {
            setItemId(index);
          },
          selected: itemId === index
        });
      })}
    </S.TabContainer>
  );
};

export const TabItem = memo(({ children, ...restProps }) => (
  <S.TabItem {...restProps}>{children}</S.TabItem>
));

export default Tab;
